import AuthSetPasswordConfirmation from './Confirmation'
export default AuthSetPasswordConfirmation
